import React from "react";

import Homepage from "./Homepage.js";
import Team from "./Team.js";
import CommercialProducts from "./CommercialProducts.js";
import Mirrors from "./Mirrors.js";
import Showers from "./Showers.js";

const routes = [
  {
    path: "/",
    exact: true,
    main: () => <Homepage />
  },
  {
    path: "/team",
    main: () => <Team />
  },
  {
    path: "/commercialproducts",
    main: () => <CommercialProducts />
  },
  {
    path: "/mirrors",
    main: () => <Mirrors />
  },
  {
    path: "/showers",
    main: () => <Showers />
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/Routes.js